module.exports = __webpack_public_path__ + "img/Jump Casting52.cde54bc8.jpg";